import * as $ from 'jquery';
import 'bootstrap';
import * as Cookies from 'js-cookie';
import {bookingFormCommon} from './c005-bookingform-common';
import * as moment from 'moment';
export class studentLoginForm{
	private $loginError:Array<string> = [];
	$loginCookieName: string      = 'MAB-Enrich-LoginID';

	loginForm(): any{
		let $loginMHNo: any            = $('.login-MHnumber');
		let $loginMHPassword: any      = $('.login-password');

		// chrome known issue:
		// unable to detect password field value/length when autofilled
		// https://stackoverflow.com/questions/35049555/chrome-autofill-autocomplete-no-value-for-password
		// https://bugs.chromium.org/p/chromium/issues/detail?id=669724
		// workaround, detect if username is autofilled, set filled state for both if yes
		if ($loginMHNo.val() != ''){
			$loginMHNo.addClass('input-focused');
			$loginMHNo.parent().find('.booking-form--title').addClass('input-filled');
			$loginMHPassword.addClass('input-focused');
			$loginMHPassword.parent().find('.booking-form--title').addClass('input-filled');
		} else {
			$loginMHNo.removeClass('input-focused');
			$loginMHNo.parent().find('.booking-form--title').removeClass('input-filled');
			$loginMHPassword.removeClass('input-focused');
			$loginMHPassword.parent().find('.booking-form--title').removeClass('input-filled');
		}
	}

	studentLoginFormSubmit(): void {
		$('.student-login-form').click((evt:any) => {
			evt.preventDefault();
			let _self: any = this;
			let $loginMHNo : any = $('.login-MHnumber');
			let $loginPassword : any = $('.login-password');
			let $loginErrorDiv : any = $('.login-error--validation');
			let $loginValidator: any = $('.login-validator');
			let $rememberMyEnrich: any = $('#login-remember--enrich');
			let $validationSuccess    : any = true;
			_self.$loginError = [];
			$loginErrorDiv.show();

			// validate Login MH no.
			if ($loginMHNo.val() == ''){
				let $loginMHNoValidate:any = $loginMHNo.attr('data-loginmhno');
				_self.$loginError.push('<strong>'+$loginMHNo.parent().find('label').text()+':</strong> '+$loginMHNoValidate);
				$loginMHNo.addClass('has-error');
				$loginMHNo.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			} else {
				$loginMHNo.removeClass('has-error');
				$loginMHNo.parent().find('.booking-form--title').removeClass('has-error');
			}

			// validate Login Password
			if ($loginPassword.val() == ''){
				let $loginPasswordValidate:any = $loginPassword.attr('data-loginmhpassword');
				_self.$loginError.push('<strong>'+$loginPassword.parent().find('label').text()+':</strong> '+$loginPasswordValidate);
				$loginPassword.addClass('has-error');
				$loginPassword.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			} else {
				$loginPassword.removeClass('has-error');
				$loginPassword.parent().find('.booking-form--title').removeClass('has-error');
			}

			let $validationContainer:any = $loginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=this.$loginError.length; i<len; i++) {
				$validationMessagelist.append('<li data-id="'+i+'">' + this.$loginError[i] + '</li>');
			}

			if ($validationSuccess) {
				$loginErrorDiv.hide();
				if($rememberMyEnrich.is(':checked')){
					let $cookieIdValue: any = $loginMHNo.val();
					Cookies.set(_self.$loginCookieName, $cookieIdValue);
				} else {
					Cookies.set(_self.$loginCookieName, '');
				}
				$loginErrorDiv.hide();

				let bcommon: any = new bookingFormCommon();
				bcommon.preloader();
				let $mhAthleteVal = $('#mhAthleteLogInVal').val();
				//alert("mhAthleteVal>>"+$mhAthleteVal);
				var data:any = {
					'userId': $loginMHNo.val(),
					'password': $loginPassword.val(),
					'mhAthleteVal': $mhAthleteVal
				};
				// if($loginMHNo.val() =='1234567'){
				// 	let $loginSuccessDiv : any = $("#exceptionmsg1");
				// 	var loginSuccess = $("#exceptionmsg1").attr("data-loginsuccess");
				// 	var expires;
				// 	var json ={
				// 		"enrichId":"13456",
				// 		"email":"test@test.com",
				// 		"age"  :"22",
				// 		"dob" : "dob",
				// 		"name" :" Mr Test",
				// 		"message" :"Message to be displayed",
				// 		"studentId":"MH000000034",
				// 		"expiryDate":"Jan 1, 2025 12:00:00 AM",
				// 		"memberSince":"Aug 29, 2018 12:00:00 AM"
				// 	};
				// 	(window as any).studentObjdashboard={
				// 		"name" :" Mr Test",
				// 		"message" :"Message to be displayed",
				// 		"studentId":"MH000000034",
				// 		"expiryDate":"Jan 1, 2025 12:00:00 AM",
				// 		"memberSince":"Aug 29, 2018 12:00:00 AM"
				// 	};
				// 	document.cookie="studentId="+json.studentId+";"+expires+";path=/";
				// 	document.cookie="studentExpiryDate="+json.expiryDate+";"+expires+";path=/";
				// 	document.cookie="studentMemberSince="+json.memberSince+";"+expires+";path=/";
				// 	document.cookie="studentEnrichId="+json.enrichId+";"+expires+";path=/";
				// 	document.cookie="student-enrichId="+json.enrichId+";"+expires+";path=/";
				// 	document.cookie="studentEmail="+json.email+";"+expires+";path=/";
				// 	document.cookie="studentDob="+json.dob+";"+expires+";path=/";
				// 	document.cookie="studentName="+json.name+";"+expires+";path=/";
				// 	document.cookie="studentAge="+json.age+";"+expires+";path=/";
				// 	$loginErrorDiv.show();
				// 	_self.$loginError.push(json.message);
				// 	window.location.href = "student-enrollment.html";
				// }
				$.ajax({
					type: 'POST',
					url:'/bin/services/new/authStudentPortalLogin',
					data: data,
					success: function(msg:any) {
						var json = JSON.parse(msg);
						var responseCode = json.code;
						var mhType=json.mhReqType;
						//alert("mhType"+mhType);
						if (responseCode == "OK" && (mhType==null || mhType=='' || mhType!="mhathlete")) {
							var loginSuccess = $("#exceptionmsg1").attr("data-loginsuccess");
							var expires ="";
							var memberSinceCookie =moment(json.memberSince).format("YYYY-MM-DD");
							var expiryDateCookie =moment(json.expiryDate).format("YYYY-MM-DD");
							document.cookie="studentId="+json.studentId+";"+expires+";path=/";
							document.cookie="studentExpiryDate="+expiryDateCookie+";"+expires+";path=/";
							document.cookie="studentMemberSince="+memberSinceCookie+";"+expires+";path=/";
							document.cookie="studentEnrichId="+json.enrichId+";"+expires+";path=/";
							document.cookie="studentEmail="+json.email+";"+expires+";path=/";
							document.cookie="studentDob="+json.dob+";"+expires+";path=/";
							document.cookie="studentName="+json.name+";"+expires+";path=/";
							document.cookie="studentAge="+json.message+";"+expires+";path=/";
							document.cookie="enrichMiles="+json.enrichMiles+";"+expires+";path=/";
							bcommon.preloaderClose();
							window.location.href = loginSuccess;
							// Redirect to the configured page from here.
						}else if (responseCode == "OK" && (mhType!=null && mhType!='' && mhType=="mhathlete")) {
							var loginSuccess = $("#exceptionmsg1").attr("data-loginsuccess");
							var expires ="";
							var memberSinceCookie =moment(json.memberSince).format("YYYY-MM-DD");
							var expiryDateCookie =moment(json.expiryDate).format("YYYY-MM-DD");
							document.cookie="athleteId="+json.studentId+";"+expires+";path=/";
							document.cookie="athleteExpiryDate="+expiryDateCookie+";"+expires+";path=/";
							document.cookie="athleteMemberSince="+memberSinceCookie+";"+expires+";path=/";
							document.cookie="athleteEnrichId="+json.enrichId+";"+expires+";path=/";
							document.cookie="athleteEmail="+json.email+";"+expires+";path=/";
							document.cookie="athleteDob="+json.dob+";"+expires+";path=/";
							document.cookie="athleteName="+json.name+";"+expires+";path=/";
							document.cookie="athleteAge="+json.message+";"+expires+";path=/";
							document.cookie="enrichMiles="+json.enrichMiles+";"+expires+";path=/";
							bcommon.preloaderClose();
							window.location.href = loginSuccess;
							// Redirect to the configured page from here.
						}
						 else if (responseCode == "NR" && (mhType==null || mhType=='' || mhType!="mhathlete")) {
							// User is a enrich member, not student portal member
							var expires ="";
							document.cookie="studentEnrichId="+json.enrichId+";"+expires+";path=/";
							document.cookie="student-enrichId="+json.enrichId+";"+expires+";path=/";
							document.cookie="studentEmail="+json.email+";"+expires+";path=/";
							document.cookie="studentDob="+json.dob+";"+expires+";path=/";
							document.cookie="studentName="+json.name+";"+expires+";path=/";
							document.cookie="studentAge="+json.message+";"+expires+";path=/";
							document.cookie="enrichMiles="+json.enrichMiles+";"+expires+";path=/";
							var studentRegister = $("#exceptionmsg2").attr("data-studentregister");
							bcommon.preloaderClose();
							window.location.href = studentRegister;
						}
						else if (responseCode == "NR" && (mhType!=null && mhType!='' && mhType=="mhathlete")) {
							// User is a enrich member, not student portal member
							var expires ="";
							document.cookie="athleteEnrichId="+json.enrichId+";"+expires+";path=/";
							document.cookie="athlete-enrichId="+json.enrichId+";"+expires+";path=/";
							document.cookie="athleteEmail="+json.email+";"+expires+";path=/";
							document.cookie="athleteDob="+json.dob+";"+expires+";path=/";
							document.cookie="athleteName="+json.name+";"+expires+";path=/";
							document.cookie="athleteAge="+json.message+";"+expires+";path=/";
							document.cookie="enrichMiles="+json.enrichMiles+";"+expires+";path=/";
							var studentRegister = $("#exceptionmsg2").attr("data-studentregister");
							bcommon.preloaderClose();
							window.location.href = studentRegister;
						}else{
								$loginErrorDiv.show();
								var errorMessage = json.message;
								var dataAttrMsg = null;
								if (responseCode == "EF") {
									dataAttrMsg = "data-failed";
								}else if (responseCode == "AE") {
									dataAttrMsg = "data-ageExd";
								}else if (responseCode == "AS") {
									dataAttrMsg = "data-ageShort";
								}else if (responseCode == "AO") {
									dataAttrMsg = "data-ageLmt";
								}else if (responseCode == "AD") {
									dataAttrMsg = "data-admnDec";
								}else if (responseCode == "AA") {
									dataAttrMsg = "data-adminAprvl";
								}else if (responseCode == "AR") {
									dataAttrMsg = "data-adminRjct";
								}else if (responseCode == "LR") {
									dataAttrMsg = "data-err";
								}else if (responseCode == "PE") {
									dataAttrMsg = "data-pstExp";
								}
								if(null!= dataAttrMsg && undefined!= $("#exceptionmsg1").attr(dataAttrMsg)){
									errorMessage = $("#exceptionmsg1").attr(dataAttrMsg);
								}
								_self.$loginError.push(errorMessage);
						}
						// } else if (responseCode == "PW") {
						// 	$loginErrorDiv.show();
						// 	$loginPassword.addClass('has-error');
						// 	$loginPassword.parent().find('.booking-form--title').addClass('has-error');
						// 	_self.$loginError.push("Invalid Password. You have 4 more attempt(s)");
						// } else if (responseCode == "LC") {
						// 	$loginErrorDiv.show();
						// 	// Show the locked user account message here.
						// 	var locked  = $("#exceptionmsg1").attr("data-locked");
						// 	$loginMHNo.addClass('has-error');
						// 	$loginPassword.addClass('has-error');
						// 	$loginPassword.parent().find('.booking-form--title').addClass('has-error');
						// 	_self.$loginError.push("<strong>Account :</strong>"+locked);
						// } else if (responseCode == "NA") {
						// 	$loginErrorDiv.show();
						// 	$loginMHNo.addClass('has-error');
						// 	$loginPassword.addClass('has-error');
						// 	$loginPassword.parent().find('.booking-form--title').addClass('has-error');
						// 	_self.$loginError.push("<strong>Account :</strong>Invalid login");
						// } else if (responseCode == "W2") {
						// 	$loginErrorDiv.show();
						// 	$loginPassword.addClass('has-error');
						// 	$loginPassword.parent().find('.booking-form--title').addClass('has-error');
						// 	_self.$loginError.push("<strong>Password :</strong>Invalid Password. You have 3 more attempt(s)");
						// } else if (responseCode == "W3") {
						// 	$loginErrorDiv.show();
						// 	$loginPassword.addClass('has-error');
						// 	$loginPassword.parent().find('.booking-form--title').addClass('has-error');
						// 	_self.$loginError.push("<strong>Password :</strong>Invalid Password. You have 2 more attempt(s)");
						// } else if (responseCode == "W4") {
						// 	$loginErrorDiv.show();
						// 	$loginPassword.addClass('has-error');
						// 	$loginPassword.parent().find('.booking-form--title').addClass('has-error');
						// 	_self.$loginError.push("<strong>Password :</strong>Invalid Password. You have 1 more attempt(s)");
						// } else if (responseCode == "ST") {
						// 	$loginErrorDiv.show();
						// 	$loginMHNo.addClass('has-error');
						// 	$loginPassword.addClass('has-error');
						// 	$loginPassword.parent().find('.booking-form--title').addClass('has-error');
						// 	_self.$loginError.push("<strong>Account :</strong>This is invalid/inactive account. Kindly contact call center for further information");
						// }	else if (responseCode == "AE") {
						// 	$loginErrorDiv.show();
						// 	$loginPassword.parent().find('.booking-form--title').addClass('has-error');
						// 	_self.$loginError.push("<strong> Age limit exceeded, not allowed to register</strong> ");
						// }else if (responseCode == "IC") {
						// 	$loginErrorDiv.show();
						// 	$loginPassword.parent().find('.booking-form--title').addClass('has-error');
						// 	_self.$loginError.push("Enrich login failed ");
						// }else if (responseCode == "NR") {
						// 	$loginErrorDiv.show();
						// 	$loginPassword.parent().find('.booking-form--title').addClass('has-error');
						// 	_self.$loginError.push("User not registered");
						// }else if (responseCode == "EX") {
						// 	$loginErrorDiv.show();
						// 	$loginPassword.parent().find('.booking-form--title').addClass('has-error');
						// 	_self.$loginError.push("User account expired");
						// }else if (responseCode == "PE") {
						// 	$loginErrorDiv.show();
						// 	$loginPassword.parent().find('.booking-form--title').addClass('has-error');
						// 	_self.$loginError.push("User account is not active, pending email confirmation");
						// }else if (responseCode == "AA") {
						// 	$loginErrorDiv.show();
						// 	$loginPassword.parent().find('.booking-form--title').addClass('has-error');
						// 	_self.$loginError.push("User account is not active, awaiting admin approval");
						// }else if (responseCode == "AR") {
						// 	$loginErrorDiv.show();
						// 	$loginPassword.parent().find('.booking-form--title').addClass('has-error');
						// 	_self.$loginError.push("User registration is rejected by Admin, please contact admin");
						// }else if (responseCode == "LE") {
						// 	$loginErrorDiv.show();
						// 	$loginPassword.parent().find('.booking-form--title').addClass('has-error');
						// 	_self.$loginError.push("Error happened while validating login");
						// }

						var $validationContainer = $loginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
						var $validationMessagelist = $validationContainer;

						for (var i = 0, len = _self.$loginError.length; i < len; i++) {
							$validationMessagelist.append('<li data-id="' + i + '">' + _self.$loginError[i] + '</li>');
						}
						bcommon.preloaderClose();
					},
					error: function(error:any) {
						bcommon.preloaderClose();
						var $validationContainer = $loginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
						var $validationMessagelist = $validationContainer;

						for (var i = 0, len = _self.$loginError.length; i < len; i++) {
							$validationMessagelist.append('<li data-id="' + i + '">' + _self.$loginError[i] + '</li>');
						}
					}
				});
			}
		});
	}
	getCookie(name:string): any {
		var value = "; " + document.cookie;
		var parts = value.split("; " + name + "=");
		var cookieVal:any;
		if (parts.length == 2) {
			cookieVal = parts.pop().split(";").shift();
			return cookieVal;
		}
	}
	studentLoginRedirect():void{
		let _self: any = this;
		let $loginMHNo : any = $('.login-MHnumber');
		let $loginPassword : any = $('.login-password');
		let $loginErrorDiv : any = $('.login-error--validation');
		let $loginValidator: any = $('.login-validator');
		let $rememberMyEnrich: any = $('#login-remember--enrich');
		let $validationSuccess    : any = true;
		_self.$loginError = [];
		let bcommon: any = new bookingFormCommon();
		//let urlParams = bcommon.getUrlVars(window.location.href);	
		let cookieAccessToken = _self.getCookie("sapphire");
		let studentid = _self.getCookie("studentEnrichId");
		if (cookieAccessToken  && cookieAccessToken!=="undefined")
		{
			bcommon.preloader();			
			var decodedToken = parseJwt(cookieAccessToken);
			let $mhAthleteVal = $('#mhAthleteLogInVal').val();
				//alert("mhAthleteVal>>"+$mhAthleteVal);
			var data = {
				'loyaltyToken':	decodedToken.extension_loyaltyToken,
				'enrichId': decodedToken.extension_flyerid,
				'mhAthleteVal': $mhAthleteVal
			};

		$.ajax({
			type: 'POST',
			url:'/bin/services/new/authStudentPortalLogin',
			data: data,
			success: function(msg:any) {
				var json = JSON.parse(msg);
				var responseCode = json.code;
				var mhType=json.mhReqType;
				//alert("mhType"+mhType);
				if (responseCode == "OK" && json.flysiswaVoucherDetails && Object.keys(json.flysiswaVoucherDetails).length !== 0) {
					document.cookie="isFlysiswaUser="+json.flysiswaVoucherDetails.isFlysiswaUser+";"+expires+";path=/";
					document.cookie="voucherCode="+json.flysiswaVoucherDetails.voucherCode+";"+expires+";path=/";
				}
				if (responseCode == "OK" && (mhType==null || mhType=='' || mhType!="mhathlete") ) {
					var loginSuccess = $("#exceptionmsg1").attr("data-loginsuccess");
					var expires ="";
					var memberSinceCookie =moment(json.memberSince).format("YYYY-MM-DD");
					var expiryDateCookie =moment(json.expiryDate).format("YYYY-MM-DD");
					document.cookie="studentId="+json.studentId+";"+expires+";path=/";
					document.cookie="studentExpiryDate="+expiryDateCookie+";"+expires+";path=/";
					document.cookie="studentMemberSince="+memberSinceCookie+";"+expires+";path=/";
					document.cookie="studentEnrichId="+json.enrichId+";"+expires+";path=/";
					document.cookie="studentEmail="+json.email+";"+expires+";path=/";
					document.cookie="studentDob="+json.dob+";"+expires+";path=/";
					document.cookie="studentName="+json.name+";"+expires+";path=/";
					document.cookie="studentAge="+json.message+";"+expires+";path=/";
					document.cookie="enrichMiles="+json.enrichMiles+";"+expires+";path=/";
					bcommon.preloaderClose();
					window.location.href = loginSuccess;
					// Redirect to the configured page from here.
				}if (responseCode == "OK" && (mhType!=null && mhType!='' && mhType=="mhathlete") ) {
					var loginSuccess = $("#exceptionmsg1").attr("data-loginsuccess");
					var expires ="";
					var memberSinceCookie =moment(json.memberSince).format("YYYY-MM-DD");
					var expiryDateCookie =moment(json.expiryDate).format("YYYY-MM-DD");
					document.cookie="athleteId="+json.studentId+";"+expires+";path=/";
					document.cookie="athleteExpiryDate="+expiryDateCookie+";"+expires+";path=/";
					document.cookie="athleteMemberSince="+memberSinceCookie+";"+expires+";path=/";
					document.cookie="athleteEnrichId="+json.enrichId+";"+expires+";path=/";
					document.cookie="athleteEmail="+json.email+";"+expires+";path=/";
					document.cookie="athleteDob="+json.dob+";"+expires+";path=/";
					document.cookie="athleteName="+json.name+";"+expires+";path=/";
					document.cookie="athleteAge="+json.message+";"+expires+";path=/";
					document.cookie="enrichMiles="+json.enrichMiles+";"+expires+";path=/";
					document.cookie="category="+json.category+";"+expires+";path=/";
					bcommon.preloaderClose();
					window.location.href = loginSuccess;
					// Redirect to the configured page from here.
				} else if (responseCode == "NR" && (mhType==null || mhType=='' || mhType!="mhathlete")) {
					// User is a enrich member, not student portal member
					var expires ="";
					document.cookie="studentEnrichId="+json.enrichId+";"+expires+";path=/";
					document.cookie="student-enrichId="+json.enrichId+";"+expires+";path=/";
					document.cookie="studentEmail="+json.email+";"+expires+";path=/";
					document.cookie="studentDob="+json.dob+";"+expires+";path=/";
					document.cookie="studentName="+json.name+";"+expires+";path=/";
					document.cookie="studentAge="+json.message+";"+expires+";path=/";
					document.cookie="enrichMiles="+json.enrichMiles+";"+expires+";path=/";
					var studentRegister = $("#exceptionmsg2").attr("data-studentregister");
					bcommon.preloaderClose();
					window.location.href = studentRegister;
				}else if (responseCode == "NR" && (mhType!=null && mhType!='' && mhType=="mhathlete")) {
					// User is a enrich member, not student portal member
					var expires ="";
					document.cookie="athleteEnrichId="+json.enrichId+";"+expires+";path=/";
					document.cookie="athlete-enrichId="+json.enrichId+";"+expires+";path=/";
					document.cookie="athleteEmail="+json.email+";"+expires+";path=/";
					document.cookie="athleteDob="+json.dob+";"+expires+";path=/";
					document.cookie="athleteName="+json.name+";"+expires+";path=/";
					document.cookie="athleteAge="+json.message+";"+expires+";path=/";
					document.cookie="enrichMiles="+json.enrichMiles+";"+expires+";path=/";
					var studentRegister = $("#exceptionmsg2").attr("data-studentregister");
					bcommon.preloaderClose();
					window.location.href = studentRegister;
				}
				else if (responseCode == "EX" && json.category == "academician" &&  (mhType==null || mhType=='' || mhType!="mhathlete")) {
					var expires ="";
					document.cookie="studentEnrichId="+json.enrichId+";"+expires+";path=/";
					document.cookie="student-enrichId="+json.enrichId+";"+expires+";path=/";
					document.cookie="studentEmail="+json.email+";"+expires+";path=/";
					document.cookie="studentDob="+json.dob+";"+expires+";path=/";
					document.cookie="studentName="+json.name+";"+expires+";path=/";
					document.cookie="studentAge="+json.message+";"+expires+";path=/";
					document.cookie="enrichMiles="+json.enrichMiles+";"+expires+";path=/";
					var renewPage = $("#exceptionmsg3").attr("data-renewPage");
					bcommon.preloaderClose();
					window.location.href = renewPage;
				}else if (responseCode == "EX" && json.category == "academician" &&  (mhType!=null && mhType!='' && mhType=="mhathlete")) {
					var expires ="";
					document.cookie="athleteEnrichId="+json.enrichId+";"+expires+";path=/";
					document.cookie="athlete-enrichId="+json.enrichId+";"+expires+";path=/";
					document.cookie="athleteEmail="+json.email+";"+expires+";path=/";
					document.cookie="athleteDob="+json.dob+";"+expires+";path=/";
					document.cookie="athleteName="+json.name+";"+expires+";path=/";
					document.cookie="athleteAge="+json.message+";"+expires+";path=/";
					document.cookie="enrichMiles="+json.enrichMiles+";"+expires+";path=/";
					var renewPage = $("#exceptionmsg3").attr("data-renewPage");
					bcommon.preloaderClose();
					window.location.href = renewPage;
				}
				else{
						$loginErrorDiv.show();
						var errorMessage = json.message;
						var dataAttrMsg = null;
						if (responseCode == "EF") {
							dataAttrMsg = "data-failed";
						}else if (responseCode == "AE") {
							dataAttrMsg = "data-ageExd";
						}else if (responseCode == "AS") {
							dataAttrMsg = "data-ageShort";
						}else if (responseCode == "AO") {
							dataAttrMsg = "data-ageLmt";
						}else if (responseCode == "AD") {
							dataAttrMsg = "data-admnDec";
						}else if (responseCode == "AA") {
							dataAttrMsg = "data-adminAprvl";
						}else if (responseCode == "AR") {
							dataAttrMsg = "data-adminRjct";
						}else if (responseCode == "LR") {
							dataAttrMsg = "data-err";
						}else if (responseCode == "PE") {
							dataAttrMsg = "data-pstExp";
						}
						if(null!= dataAttrMsg && undefined!= $("#exceptionmsg1").attr(dataAttrMsg)){
							errorMessage = $("#exceptionmsg1").attr(dataAttrMsg);
						}
						_self.$loginError.push(errorMessage);
						window.scrollTo(0, 600);
				}
				var $validationContainer = $loginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
				var $validationMessagelist = $validationContainer;

				for (var i = 0, len = _self.$loginError.length; i < len; i++) {
					$validationMessagelist.append('<li data-id="' + i + '">' + _self.$loginError[i] + '</li>');
				}
				bcommon.preloaderClose();
			},
			error: function(error:any) {
				bcommon.preloaderClose();
				var $validationContainer = $loginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
				var $validationMessagelist = $validationContainer;

				for (var i = 0, len = _self.$loginError.length; i < len; i++) {
					$validationMessagelist.append('<li data-id="' + i + '">' + _self.$loginError[i] + '</li>');
				}
			}
		});
		}
		function parseJwt (token:any): any {
			var base64Url = token.split('.')[1];
			var base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));
		
			return JSON.parse(base64);
		};

	}

}

let scope:Element = document.querySelector('.login-component');
let scopeSignup:Element = document.querySelector('.student-enrollment-component');
if (scope != null && scopeSignup == null){
	try {
	let $loginBtn = $(scope).find('button.student-login-form');
	let loginform = new studentLoginForm();
			loginform.loginForm();
			//loginform.studentLoginFormSubmit();
			loginform.studentLoginRedirect();
			$loginBtn.removeAttr('disabled');
	} catch(e) {console.error(e);}
}